module.exports = __webpack_public_path__ + "media/src/images/usr_txt_dev-b7ac117402957a4aedf9e881faf9f0e5.png";